import React from 'react';

import { Pane, Icon } from 'evergreen-ui';

import { StyledNotFound } from './styled';

const NotFound = () => (
	<StyledNotFound className="d-flex align-items-center">
		<Pane>
			<Icon icon="warning-sign" color="warning" marginRight={10} />
		</Pane>

		<span>Ops! Não conseguimos encontrar informações deste gráfico.</span>
	</StyledNotFound>
);

export default NotFound;
